// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/landing-gear-types.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/landing-gear-types/landing-gear-types.js';

mount([g0]);
